function SampleNextArrow(props: any) {
  const { className, onClick } = props;
  return (
    <div
      className={className}
      // style={{ ...style, display: 'block' }}
      onClick={onClick}
    ></div>
  );
}

function SamplePrevArrow(props: any) {
  const { className, onClick } = props;
  return (
    <div
      className={className}
      // style={{ ...style, display: 'block' }}
      onClick={onClick}
    />
  );
}

export const testimonialSettings = {
  dots: false,
  customPaging: (i: number) => (
    <div
      // style={{
      //   position: 'absolute',
      //   width: '100%',
      //   top: '-6px',
      //   opacity: '0',
      // }}
      className="dg_testimonial-settings"
    >
      {i + 1}
    </div>
  ),
  dotsClass: 'prizes-dots',
  infinite: true,
  speed: 500,
  slidesToShow: 2.8, // 3.0
  slidesToScroll: 1,
  initialSlide: 0,
  arrows: true,
  autoplay: true,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
